import { render, staticRenderFns } from "./ReopenWorkOrdersNewModal.vue?vue&type=template&id=315f2c42&"
import script from "./ReopenWorkOrdersNewModal.vue?vue&type=script&lang=js&"
export * from "./ReopenWorkOrdersNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports